<template>
  <div>
    <Spinner v-show="loading" />
    <div class="whitebox row" v-show="!loading">
      <h3 v-html="heading" />
      <hr class="mb-4" />
      <ul class="col-12 xcol-xl-6">
        <ListItem
          v-for="(queue, i) in items"
          :key="i"
          :title="queue[title]"
          :description="queue[description]"
          :icons="icons || queue[icons_attribute]"
          :titleWeight="titleWeight"
          :onSelection="selected"
          @click.native="selected(queue)"
          :item="queue"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import Spinner from "../components/Spinner";
import ListItem from "../components/ListItem";

export default {
  name: "ListBox",
  components: {
    Spinner,
    ListItem,
  },
  props: {
    heading: String,
    title: String,
    description: String,
    icons_attribute: String,
    icons: Array,
    items: Array,
    onSelect: Function,
    titleWeight: Number,
    loading: Boolean,
  },
  methods: {
    selected(q) {
      window.console.log("selected>", q);
      this.onSelect(q);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  padding-left: 0;
}

li {
  display: block;
}
</style>
